type AppConfig = {
  ENVIRONMENT: string
  API_URL: string
  AUTH_API_URL: string
  CORE_URL: string
  APP_NEW_API_URL: string
  MANAGER_URL: string
  FORM_URL: string
  MANAGER_NEW_API_URL: string
  VITE_APP_NAME: string
  // Optional
  DEALER_NEW_API_URL?: string
  VITE_APP_INSTRUMENTATION_KEY?: string
}

const getEnvVar = (key: string, fallback?: string, required = true): string => {
  let value = process.env[key] || fallback
  if (value === undefined && required) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  return value || ''
}

export const config: AppConfig = {
  // ENVIRONMENT
  ENVIRONMENT: getEnvVar('VITE_ENVIRONMENT', 'local'),
  VITE_APP_NAME: getEnvVar('VITE_APP_NAME'),

  // LEGACY
  API_URL: getEnvVar('VITE_API_URL'),
  // AUTH
  AUTH_API_URL: getEnvVar('VITE_AUTH_API_URL'),

  // FRONTEND's
  CORE_URL: getEnvVar('VITE_CORE_URL'),
  MANAGER_URL: getEnvVar('VITE_MANAGER_URL'),
  FORM_URL: getEnvVar('VITE_FORM_URL'),

  // BACKEND for FRONTEND's
  MANAGER_NEW_API_URL: getEnvVar('VITE_MANAGER_NEW_API_URL'),
  APP_NEW_API_URL: getEnvVar('VITE_APP_NEW_API_URL'),
  DEALER_NEW_API_URL: getEnvVar('VITE_DEALER_NEW_API_URL', undefined, false),

  // INSTRUMENTATION
  VITE_APP_INSTRUMENTATION_KEY: getEnvVar('VITE_APP_INSTRUMENTATION_KEY', undefined, false),
}
